import { WORKFLOWS_GET_FOLDER_LIST_API } from "Constant/api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { authService } from "Service/Axios";

export const useFolderListWorkflow = () => {
    const [folderList, setFolderList] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchFolderList = async () => {
        try {
            const response = await authService(
                WORKFLOWS_GET_FOLDER_LIST_API,
                "POST",
                {}
            );
            setFolderList(response);
        } catch (error) {
            toast.error("Error fetching folder list:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFolderList();
    }, []);

    return { folderList, loading, fetchFolderList };
};